import { Button, Modal } from '@mairistem/composants';
import React from 'react';

interface ConfirmationOpenAutorisationModalProps {
	onClose: () => void;
	onOpenAutorisation: () => void;
}

const ConfirmationOpenAutorisationModal = ({
	onClose,
	onOpenAutorisation,
}: ConfirmationOpenAutorisationModalProps) => {
	const handleClickOuvrirAutorisation = () => {
		onOpenAutorisation();
		onClose();
	};

	return (
		<Modal open size="medium" onClose={onClose}>
			<Modal.Header>Imputer les crédits de paiement</Modal.Header>

			<Modal.Content>
				<p>Les crédits de paiement ont été rééchelonnés.</p>
				<p>
					Souhaitez-vous accéder à la fiche de l'autorisation de programme pour
					procéder à leur imputation ?
				</p>
			</Modal.Content>

			<Modal.Actions>
				<Button
					content="Annuler"
					data-testid="modalAutorisationCancelButton"
					onClick={() => onClose()}
				/>

				<Button
					content="Ouvrir l'autorisation"
					data-testid="reechelonementCreditModalCreateButton"
					onClick={handleClickOuvrirAutorisation}
					positive
				/>
			</Modal.Actions>
		</Modal>
	);
};

export default ConfirmationOpenAutorisationModal;
